import { Component, OnInit } from '@angular/core';
import { ControllerService } from '../shared/services/controller.service';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { HttpService } from '../shared/services/http.service';
import { AuthService } from '../auth/auth.service';
import { StoreHelper } from '../shared/helpers/store.helper';

declare var $: any

@Component({
    selector: 'app-library',
    templateUrl: './library.component.html',
    styleUrls: ['./library.component.scss'],
    standalone: false
})
export class LibraryComponent implements OnInit {


  filterButtons = [{type:'video', label: 'videos', itemLabel:'video'},{type:'podcast', label: 'podcasts', itemLabel:'podcast'},{type:'research',label:'research'},{type:'insights',label:'insights', itemLabel:'insight'  },{type:'practical tips', label:'practical tips', itemLabel:'practical tip'},{type:'link',label:'links', itemLabel:'link'}, {type:'reflection', label:'activities', itemLabel:'activity'}, {type:'case studies',label: 'case studies', itemLabel:'case studies'}]

  unfilteredContent = []

  activeFilters = []

  themeColors = ['#F5A623', '#F97316', '#E53935', '#3B82F6', '#8B5CF6', '#4FCB8E', '#68A8E4', '#E9B44C']

  themes: { label: string, count: number, color: string }[] = []
  activeTheme = ''
  useThemes = false

  baseImageUrl = environment.audioBaseDir + '/library/images/'
  filteredContent = []

  typeOrder = new Map([
    ['video', 1],
    ['podcast', 2],
    ['research', 3]
  ]);

  hrUser = false


  constructor(public controller:ControllerService, private router: Router, private httpService: HttpService, private authService: AuthService
  ) { }

  isHrUser() {
    return this.authService.isAuthenticatedHr() ? true : false;
  }


  async ngOnInit() {

    this.controller.shiftContainerToTop()


    if( this.isHrUser() && !this.controller.getPreviewing()){
      const clientName = StoreHelper.getCurrentUser().client_name
      this.controller.shiftContainerToTop()
      this.router.navigate([`client/${clientName}/report`]);
      return
    }

    this.controller.setErrorMessage("")

    if( !this.controller.getPreviewing() ){
      this.controller.setupLibrary(false)
    }

    this.controller.setDoneTraining()

    this.unfilteredContent = this.controller.getLibraryContents()

    const regex = /[()|]|\b(?:updated|previous|staff|primary|secondary|student|version)\b/gi;

    const themes = this.unfilteredContent.reduce( (acc: never | Set<string>, it : never| any) => {
      if( !it ){
        return acc
      }
      it['descriptions'].split(';').forEach( (description:string) => {
        const theme = description.replace(regex, '').replace(/\s+/g, ' ').trim();

        if( !it.themes ){
          it.themes = new Set()
        }

        it.themes.add(theme)

        if( it.themes.size > 1 ){
          it.themes = new Set()
          it.themes.add('General')
          acc.add('General')
        }

        acc.add(theme)
      })
      return acc
    }, new Set() )

    this.useThemes = this.authService.isEducation()

    this.themes = [...themes]
      .map((theme: string) => ({
        label: theme,
        count: this.unfilteredContent.filter((it: any) => it?.themes?.has(theme)).length
      }))
      .sort((a, b) => {
        if( a.label == 'General' ){ return 1 }
        if( b.label == 'General' ){ return -1 }
        return b.count - a.count
      })
      .map((theme, i) => ({ ...theme, color: this.themeColors[i % this.themeColors.length] }))

    this.activeTheme = this.controller.getLibraryTheme() || this.themes[0].label

    this.controller.setLibraryTheme(this.activeTheme)

    const availableTypes = this.unfilteredContent
    .map( it => it.metadata.properties['content-type'] )
    .reduce( (acc,it) => acc.add(it), new Set() )

    this.filterButtons = this.filterButtons.filter( it => availableTypes.has(it.type))

    this.filteredContent = [...this.unfilteredContent]

    this.filteredContent.sort((a, b) => {
      return this.typeOrder.get(a.metadata.properties['content-type']) - this.typeOrder.get(b.metadata.properties['content-type']);
    });

    this.applyFilters()

  }

  returnToTraining(){
      this.router.navigate(['start'])
  }

  goBack(){
    const clientName = StoreHelper.getCurrentUser().client_name
    this.controller.setPreviewing(false)
    this.controller.shiftContainerToTop()
    this.router.navigate([`client/${clientName}/report`])
  }

  loadLibraryContent( contentId ){

    this.controller.loadHemisphere(contentId, this.controller.getPreviewing(), true);

    this.controller.resume(0)
    this.controller.shiftContainerToMiddle()

  }

  getDuration( content ){
    let [mm, ss] = content.metadata && content.metadata.properties && content.metadata.properties.duration ? content.metadata.properties.duration.split(':') : [0,0]

    if ( ss >= 30 ){
      mm = parseInt(mm) + 1
    }

    return mm
  }

  getContentType( content, getRawType = false ){
    const contentType = content.metadata.properties['content-type']
    if( getRawType ){
      return contentType
    }
    const itemLabel = this.filterButtons.find( it => it.type == contentType )?.itemLabel

    return itemLabel ? itemLabel : contentType
  }

  getImageUrl( content ){
    return `url("${this.baseImageUrl + content.metadata.properties.image}")`
  }

  filter( event, contentType ){


    if( this.activeFilters.includes(contentType) ){
      event.target.classList.remove('selected')
      this.activeFilters = this.activeFilters.filter( (it) => it != contentType )
    }else{

      $('.content-filter .all').removeClass('selected')

      event.target.classList.add('selected')
      if( contentType != 'all' ){
        this.activeFilters.push(contentType)
      }
    }


    if( contentType == 'all' ){
      this.activeFilters.length = 0
    }

    if( this.activeFilters.length == 0 ){
      $('.content-filter .all').addClass('selected')
      $('.content-filter .selected:not(.all)').removeClass('selected')
    }

    this.applyFilters()
  }

  selectTheme( theme: string ){
    this.activeTheme = theme
    this.controller.setLibraryTheme(theme)
    this.applyFilters()
  }

  getActiveThemeCount(){
    if( !this.activeTheme ){
      return this.unfilteredContent.length
    }
    return this.themes.find( it => it.label == this.activeTheme )?.count ?? 0
  }

  getActiveThemeColor(){
    return this.themes.find( it => it.label == this.activeTheme )?.color ?? '#ffffff'
  }

  applyFilters(){
    let content: any[] = this.activeTheme
      ? this.unfilteredContent.filter( (it: any) => it?.themes?.has(this.activeTheme) )
      : this.unfilteredContent

    if( this.activeFilters.length > 0 ){
      content = content.filter( (it: any) => this.activeFilters.includes( it.metadata.properties['content-type']) )
    }

    this.filteredContent = [...content]
  }
}
